define('shoptheme/components/layout/messages',[
	"cartware/components/_base",
	"jquery"
], function(
	Component,
	$
) {
	return Component.create({
		$init: function() {
			var messages = $("ul.messages");
			if (messages.length > 0) {
				$(".notice-msg ul li", messages).prepend("<i class='icon-message-notice'></i>");
				$(".success-msg ul li", messages).prepend("<i class='icon-added-to-cart-check'></i>");
				$(".error-msg ul li", messages).prepend("<i class='icon-message-error'></i>");
			}
		}
	});
});
